var map = {
	"./bar.svg": 1006,
	"./estate.svg": 4293,
	"./factory.svg": 6602,
	"./line.svg": 4827,
	"./more.svg": 6172,
	"./oil.svg": 5755,
	"./oval.svg": 876,
	"./rocket.svg": 1134,
	"./team.svg": 1327,
	"./tie.svg": 5859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9409;